module.exports = __webpack_public_path__ + "static/media/techniax.030a3975.png";